/** Pill de status da persona (Ativo / Rascunho / Descontinuado). */

import { statusLabel, statusPillModifier } from './persona-labels';

import type { PersonaStatus } from './types';

export function PersonaStatusPill({ status }: { status: PersonaStatus }): JSX.Element {
  return (
    <span className={`pe-status-pill pe-status-pill--${statusPillModifier(status)}`}>
      <span className="pe-status-pill__dot" aria-hidden />
      {statusLabel(status)}
    </span>
  );
}
